export const theme = {
    initialColorMode: 'system',
    useSystemColorMode: true,
    colors: {
        primary: {
            50: '#daffff',
            100: '#affff8',
            200: '#80fff3',
            300: '#52ffee',
            400: '#2ffeea',
            500: '#21e5d0',
            600: '#10b3a2',
            700: '#008074',
            800: '#004d45',
            900: '#001c17',
          },
        background: {
            dark: "#1f1f1f",
            light: "#fff"
        },
    },
    shadows: {
        outline: 'inherit'
    }
}

export default theme
